import { Box } from "@mui/material";
import { sectionIds } from "../../const/course";
import type { CourseDetailsPageData } from "../../hook/useCourseDetailsPageData";
import { getSectionTitle, getSharingEmbedUrl, getSharingPreviewImage } from "../../util/course";
import MediaTile from "./MediaTile";
import RevealSection from "./RevealSection";
import SectionShell from "./SectionShell";

export type SharingSectionProps = Readonly<{
  data: CourseDetailsPageData;
}>;

export default function SharingSection({ data }: SharingSectionProps) {
  return (
    <RevealSection>
      <SectionShell id="sharing" title={getSectionTitle(data.pageMap, sectionIds.sharing)}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }, gap: 3 }}>
          {data.sharingItems.map((item) => (
            <MediaTile
              key={item.id}
              title={item.title}
              thumbnailImage={getSharingPreviewImage(item, data.heroImage)}
              isVideo
              embedUrl={getSharingEmbedUrl(item)}
              isPlaying={data.playingVideoId === item.id}
              onPlayToggle={() => data.togglePlayingVideo(item.id)}
              actionLabel="播放影片"
              onAction={() => data.togglePlayingVideo(item.id)}
            />
          ))}
        </Box>
      </SectionShell>
    </RevealSection>
  );
}
